import React, { useEffect } from 'react';

type Props = {
  job?: {
    id: string;
    title: string;
    location: {
      name: string;
    };
    content: string;
    absolute_url: string;
  };
  onClose: () => void;
};

const htmlDecode = (content: string) => {
  const element = document.createElement('div');
  element.innerHTML = content;
  return element.childNodes.length === 0
    ? ''
    : element.childNodes[0]
    ? (element.childNodes[0].nodeValue as string)
    : '';
};

export const JobModal = ({ job, onClose }: Props) => {
  useEffect(() => {
    const detectClick = (e: Event) => {
      const target = e.target as Element;
      const isOutsideContent = !target.closest('.career-modal-content');
      const closeBtn = target.closest('button');
      const isCloseBtn = closeBtn && closeBtn.matches('.career-close-btn');
      if (target && (isOutsideContent || isCloseBtn)) {
        onClose();
      }
    };
    document.addEventListener('click', detectClick);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('click', detectClick);
      document.body.style.overflow = 'auto';
    };
  }, [onClose]);
  return (
    <div className="career-job-modal">
      <div className="career-modal-content">
        {job ? (
          <>
            <h4 className="job-title">{job.title}</h4>
            <p className="job-location">{job.location.name}</p>
            <div dangerouslySetInnerHTML={{ __html: htmlDecode(job.content) }} />
            <div className="job-apply-container">
              <a className="job-apply hero-button" href={`https://boards.greenhouse.io/aloyoga/jobs/${job.id}#app`}>
                Apply Now
              </a>
            </div>
          </>
        ) : (
          <p className="job-loading">Loading...</p>
        )}
        <div className="career-modal-close">
          <button className="career-close-btn">
            <span className="alo-cross-white-icon" style={{ width: '28px', height: '28px' }}></span>
          </button>
        </div>
      </div>
    </div>
  );
};
